/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import objectPath from "object-path";
import { withRouter } from "react-router-dom";
import * as builder from "../../ducks/builder";
import BreadCrumbs from "./components/BreadCrumbs";
import { usePageData } from "../../../provider/PageDataProvider";
import BootstrapTooltip from "../../../app/partials/content/BootstrapTooltip";
import { useGlobalData } from "../../../provider/GlobalDataProvider";

function SubHeader({
  subheaderCssClasses,
  subheaderContainerCssClasses,
  subheaderMobileToggle,
}) {
  const { reload } = useGlobalData();
  const {
    pageTitle,
    pageBreadcrumbs,
    actionButtons,
    actionGroupButtons,
    saveButton,
  } = usePageData();

  useEffect(() => {}, [reload]);

  return (
    <div
      id="kt_subheader"
      className={`kt-subheader ${subheaderCssClasses} kt-grid__item`}
    >
      <div className={`kt-container ${subheaderContainerCssClasses}`}>
        <div className="kt-subheader__main">
          {subheaderMobileToggle && (
            <button
              className="kt-subheader__mobile-toggle kt-subheader__mobile-toggle--left"
              id="kt_subheader_mobile_toggle"
            >
              <span />
            </button>
          )}

          <h3 className="kt-subheader__title">{pageTitle}</h3>
          <span className="kt-subheader__separator kt-subheader__separator--v" />
          <BreadCrumbs items={pageBreadcrumbs} />
          {/*<span className="kt-subheader__desc">#XRS-45670</span>*/}
        </div>

        <div className="kt-subheader__toolbar">
          <div className="kt-subheader__wrapper">
            {actionButtons?.map((button, index) => (
              <button
                key={index}
                type="button"
                onClick={button.onClick}
                className={`btn btn-${button.color} btn-md btn-pill btn-bold`}
              >
                <i className={button.icon}></i>
                {button.title}
              </button>
            ))}

            {actionGroupButtons && actionGroupButtons.length > 0 ? (
              <div
                className="btn-group btn-group-md"
                role="group"
                data-toggle="button"
              >
                {actionGroupButtons.map((button, index) => (
                  <BootstrapTooltip key={index} title={button.tooltip}>
                    <button
                      type="button"
                      className={`btn btn-${
                        button.activeButton === button.tooltip
                          ? button.activeColor
                          : button.color
                      } btn-md btn-pill btn-bold ml-0`}
                      onClick={() => {
                        button.onClick();
                      }}
                    >
                      <i
                        className={`${button.icon}${
                          button.title === "" ? " pr-0" : ""
                        }`}
                      ></i>{" "}
                      {button.title}
                    </button>
                  </BootstrapTooltip>
                ))}
              </div>
            ) : null}

            {saveButton.showButton ? (
              <button
                type="submit"
                className="btn btn-success btn-md btn-pill btn-bold"
                onClick={saveButton.onClick}
              >
                <i className="fas fa-save"></i>
                Save
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (store) => ({
  config: store.builder.layoutConfig,
  menuConfig: store.builder.menuConfig,
  subheaderMobileToggle: objectPath.get(
    store.builder.layoutConfig,
    "subheader.mobile-toggle"
  ),
  subheaderCssClasses: builder.selectors.getClasses(store, {
    path: "subheader",
    toString: true,
  }),
  subheaderContainerCssClasses: builder.selectors.getClasses(store, {
    path: "subheader_container",
    toString: true,
  }),
});

export default withRouter(connect(mapStateToProps)(SubHeader));
